import pegasus from "../../assets/scripts/global/01-pegasus";

export default class CountryList {
    /**
     * @var {boolean}
     */
    open = false;

    init() {
        pegasus.onResizeFinished(() => {
            this.open = window.innerWidth > 768;
        }, true);
    }
    
}

document.addEventListener("alpine:init", () => {
    Alpine.data("countryList", () => new CountryList());
});
